import config from '../../config';
import { makeAPICall, APIError } from '../generalCreators';
import { getOrganisation } from '../organisations/basicCreators';

export function updateCurrentLocation(organisationId, withSettings = true) {
  return function(dispatch, getState) {
    if (organisationId) {
      // Get the location details
      return dispatch(getOrganisation(organisationId, withSettings)).then(
        location => {
          dispatch({ type: 'UPDATE_CURRENT_LOCATION', location });
          dispatch(updateCurrentLocationPermissions(organisationId));
        }
      );
    } else {
      return dispatch({ type: 'CLEAR_CURRENT_LOCATION' });
    }
  };
}

export function updateCurrentLocationPermissions(organisationId) {
  return function(dispatch, getState) {
    const endpoint = '/user/current/permissions';
    const options = {
      method: 'GET',
      headers: { token: getState().authentication.token },
      params: {
        productId: config.productId,
        organisationId
      }
    };

    return makeAPICall(endpoint, options).then(
      response => {
        const permissions = response.data.permissions;
        dispatch({ type: 'UPDATE_CURRENT_LOCATION_PERMISSIONS', permissions });
      },
      error =>
        dispatch(
          APIError(
            error,
            'Error updating current location permissions for logged in user'
          )
        )
    );
  };
}

export function clearCurrentLocation(): Action {
  return { type: 'CLEAR_CURRENT_LOCATION' };
}

export function clearLocations(): Action {
  return { type: 'CLEAR_LOCATIONS' };
}



// WEBPACK FOOTER //
// ./src/actions/locations/currentLocationCreators.js